import { combineReducers } from 'redux';
import globalReducer from './globalReducer';
import authReducer from './authReducer';
import modeReducer from './modeReducer';
import currentPageReducer from './currentPageReducer';
import moduleReducer from './moduleReducer';

const appReducer = combineReducers({
  global: globalReducer,
  auth: authReducer,
  mode: modeReducer,
  currentPage: currentPageReducer,
  module: moduleReducer,
});
const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined;
  }
  return appReducer(state, action);
};
export default rootReducer;
